import React from "react";
import { useTranslation } from "react-i18next";
import "./monitoringAccount.scss";

function MonitoringAccount() {
  const { t } = useTranslation()

  return (
    <div className="container-monitoring-account">
      <div className="texts-monitoring-account">
        <h1>{t("financial_services.monitor_account.title")}</h1>
        <p>{t("financial_services.monitor_account.section_text_1")}</p>
        <p>{t("financial_services.monitor_account.section_text_2")}</p>
      </div>
    </div>
  );
}

export default MonitoringAccount;
